import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Japanese%20shrine%20at%20twilight%20with%20warm%20golden%20lanterns%20glowing%2C%20traditional%20wooden%20torii%20gate%20silhouette%2C%20cherry%20blossom%20petals%20drifting%20in%20breeze%2C%20majestic%20mountain%20background%2C%20ethereal%20atmosphere%2C%20stunning%20cinematic%20lighting%2C%20rich%20warm%20tones%2C%20high%20detail%20photorealistic&width=1800&height=900&seq=hero-bg-2026&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <div className="flex items-center justify-center gap-2 mb-6">
            <span className="w-8 h-px bg-accent-400/60"></span>
            <span className="text-accent-300 text-sm tracking-widest font-label uppercase">
              官方正版 · 权威平台
            </span>
            <span className="w-8 h-px bg-accent-400/60"></span>
          </div>
          <h1 className="font-heading text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            琉璃神社
          </h1>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl mx-auto">
            提供最新官方公告、正版资源下载、会员专属服务及创作者社区互动。
            这里是粉丝与创作者共同的权威信息平台。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/announcements"
              className="px-8 py-3 rounded-full bg-primary-500 text-white font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap text-sm"
            >
              查看最新公告
            </Link>
            <Link
              to="/category/membership"
              className="px-8 py-3 rounded-full border-2 border-white/40 text-white font-semibold hover:bg-white/10 transition-colors whitespace-nowrap text-sm"
            >
              了解会员权益
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}